import { FC, useState } from 'react'
import styled from 'styled-components'
import { LandingPageSection } from '@/network/graphql.g'
import { Flex } from '@/components/atoms/Grid'
import { H1 } from '@/components/atoms/typography'
import { MediaContextProvider } from '@/components/atoms/media'
import Link from '@/components/atoms/link'

import ValentineSubCategories from './subCategories'
import { getImageUrlCategories } from './getImageUrl'
import { ArrowDownIconDefault } from '@/components/atoms/icons/ArrowDownIconDefault'
import { ArrowUpIconDefault } from '@/components/atoms/icons/ArrowUpIconDefault'

type ChristmasCategoriesContainerProps = {
  category: LandingPageSection
}

const ChristmasCategoriesContainer: FC<ChristmasCategoriesContainerProps> = ({
  category
}) => {
  const [opened, setOpened] = useState<boolean>(true)

  const toggleOpened = () => {
    setOpened(!opened)
  }

  return (
    <MediaContextProvider>
      <Flex flexDirection="column">
        {category.link ? (
          <Link href={category.link}>
            <TitleWrapper
              height="420px"
              position={category.position}
              hasSubCategories={!category.categories}
            >
              <StyledH1>{category.name}</StyledH1>
            </TitleWrapper>
          </Link>
        ) : (
          <TitleWrapper
            height="420px"
            position={category.position}
            hasSubCategories={!category.categories}
          >
            <StyledH1>{category.name}</StyledH1>
          </TitleWrapper>
        )}
        {category.categories && (
          <div onClick={toggleOpened}>
            <IconWrapper>
              {opened ? <ArrowUpIconDefault /> : <ArrowDownIconDefault />}
            </IconWrapper>
          </div>
        )}
        {category.categories && opened && (
          <ValentineSubCategories valentineCategory={category} />
        )}
      </Flex>
    </MediaContextProvider>
  )
}

export default ChristmasCategoriesContainer

const TitleWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  width: 100%;
  background-image: ${(props) =>
    `url(${getImageUrlCategories(props.position)})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 20%;
  margin-bottom: ${(props) => props.hasSubCategories && '30px'};
`

const StyledH1 = styled(H1)`
  font-size: 32px;
  letter-spacing: 2px;
  color: ${(props) => props.theme.colors.background};
  text-shadow: 1px 1px 0px ${(props) => props.theme.colors.sizeTableDescription};
`

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.giftCardBackground};
  margin: 0 auto;
  cursor: pointer;
  top: -180px;
  position: relative;
`
